import type { FlagsType } from '@iheartjane/feature-flags';
import type { QueryClient } from '@tanstack/react-query';
import type { RouteObject } from 'react-router';
import { Navigate } from 'react-router';

import { Toasts } from './components';
import { rootLoader } from './data-access';
import { ErrorPage } from './pages/ErrorPage';
import { LogoPage } from './pages/LogoPage';
import { AppProvider } from './providers';
import { authenticateRoute } from './routing/authenticateRoute';
import { kioskRoutes } from './routing/kioskRoutes';
import { kioskV1Routes } from './routing/kioskV1Routes';
import { mobileDeviceRoutes } from './routing/mobileRoutes';

const storeBase = '/stores/:storeId';

const root = (queryClient: QueryClient, flags: FlagsType): RouteObject => ({
  children: [
    kioskV1Routes(),
    authenticateRoute(queryClient),
    kioskRoutes(queryClient, flags),
    mobileDeviceRoutes(),
  ],
  element: <AppProvider renderToasts={Toasts} />,
  errorElement: <ErrorPage />,
  id: 'root',
  loader: rootLoader(queryClient),
  path: storeBase,
});

export const createRoutes = (
  queryClient: QueryClient,
  flags: FlagsType
): RouteObject[] => {
  return [
    {
      index: true,
      element: <LogoPage />,
      errorElement: <ErrorPage />,
      path: '/',
    },
    root(queryClient, flags),
    {
      element: <Navigate to="/" />,
      errorElement: <ErrorPage />,
      path: '*',
    },
  ];
};
